module.exports = __webpack_public_path__ + "img/16.4891d63e.svg";